import { render, staticRenderFns } from "./VerifyDefinitive.vue?vue&type=template&id=0a8dfb88&scoped=true&"
import script from "./VerifyDefinitive.vue?vue&type=script&lang=js&"
export * from "./VerifyDefinitive.vue?vue&type=script&lang=js&"
import style0 from "./VerifyDefinitive.vue?vue&type=style&index=0&id=0a8dfb88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8dfb88",
  null
  
)

export default component.exports